export const candycoatedbrights = {
  name: 'Candy-coated Brights',
  color: [0.8823529411764706, 0.19215686274509805, 0.34509803921568627, 1],
  bg: [0.9215686274509803, 0.5411764705882353, 0.26666666666666666, 1],
  grid1: [1, 0.9254901960784314, 0.3607843137254902, 1],
  grid2: [0, 0.5529411764705883, 0.796078431372549, 1],
}
